import { useFiltersState } from './useFiltersState';

export function useSelectedLabelIds(): string[] {
  const [filtersState] = useFiltersState();

  return filtersState.labelIds;
}
